import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskAppsFieldsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-apps-fields',
	path: '/jira/servicedesk/projects/:projectKey/settings/apps/app-fields',
	exact: true,
};
